import { render } from "./MessageBox.vue?vue&type=template&id=120f7d6b&scoped=true"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=120f7d6b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-120f7d6b"

export default script